/**
 * Custom Input Spinner Logic
 * Handles increment and decrement buttons for number inputs
 */

export function initInputSpinner() {
	// Handle custom spinner controls
	const spinnerBtns = document.querySelectorAll('.spinner-btn');

	spinnerBtns.forEach(btn => {
		btn.addEventListener('click', (e) => {
			// Prevent event bubbling if necessary, though usually not needed for button type="button"
			e.preventDefault();

			const wrapper = btn.closest('.form-input');
			if (!wrapper) return;

			const input = wrapper.querySelector('input[type="number"]');
			if (!input) return;

			const step = parseFloat(input.getAttribute('step')) || 1;
			const min = parseFloat(input.getAttribute('min'));
			const max = parseFloat(input.getAttribute('max'));

			let val = parseFloat(input.value) || 0;

			if (btn.classList.contains('spinner-up')) {
				val += step;
			} else {
				val -= step;
			}

			// Check min constraint
			if (!isNaN(min) && val < min) {
				val = min;
			}

			// Check max constraint
			if (!isNaN(max) && val > max) {
				val = max;
			}

			// Fix floating point precision issues
			input.value = parseFloat(val.toFixed(1));
		});
	});
}
